import { Colors, Lightning } from "@lightningjs/sdk";
import { Theme, themeManager } from "../../../../components/configurations/Theme/ThemeManager";
import theme from "../../../../lib/theme";

interface MovieNameTemplateSpec extends Lightning.Component.TemplateSpec {
    maxW: number;
}

export class MovieName
    extends Lightning.Component<MovieNameTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<MovieNameTemplateSpec>
{
    private _themeCallback!: (theme: Theme | undefined) => void;

    static override _template(): Lightning.Component.Template<MovieNameTemplateSpec> {
        return {
            text: {
                text: "",
                fontSize: theme.banner.title.font.size,
                fontFace: theme.banner.title.font.face,
                wordWrap: true,
                lineHeight: theme.banner.title.font.size + 4,
                wordWrapWidth: 1400,
                maxLines: 3,
                textOverflow: "ellipsis"
            }
        };
    }
    override _detach() {
        themeManager.unsubscribe(this._themeCallback);
    }

    override _init() {
        this._themeCallback = this._onThemeChange.bind(this);
        themeManager.subscribe(this._themeCallback);
    }

    private _onThemeChange(customTheme: Theme | undefined): void {
        this.patch({
            text: {
                textColor: customTheme?.title ?? Colors(theme.colors.text.primary).get()
            }
        });
    }

    set maxW(w: number) {
        this.patch({
            text: {
                wordWrapWidth: w
            }
        });
    }
}
